import './index.scss'
import React from 'react'
import { connect } from 'react-redux'
import superagent from 'superagent'
import Fingerprint2 from 'fingerprintjs2'
import logoIcon from '../../../../../asset/BaseMapLogo.png'

class ForgotPasswordDialog extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      email: '',
      password: '',
      emailError: '',
      ipAddress: '',
      platform: '',
      emailSent: false,
      psdSent: false
    }
  }
  componentDidMount() {
    let regex = /\bpassword-reset\b/
    let url = window.location.href
    if (regex.test(url)) {
      this.setState({ passwordReset: true })
    }

    this.getIpAddress()
    this.getPlatform()
  }
  getPlatform() {
    Fingerprint2.getV18({},
      function (result, components) {
        let platform = components[14].value
        this.setState({ platform: platform })
      }.bind(this)
    )
  }

  getIpAddress() {
    $(document).ready(
      function () {
        $.getJSON(
          'https://jsonip.com/?callback=?',
          function (data) {
            let ip = data.ip
            this.setState({ ipAddress: ip })
          }.bind(this)
        )
      }.bind(this)
    )
  }

  handleChange(event) {
    const { name, value } = event.target
    this.setState({
      [name]: value
    })
  }

  validEmail = email => {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    return re.test(email)
  }

  handlePasswordReset = function (e) {
    e.preventDefault()

    if (this.state.email && this.validEmail(this.state.email)) {
      return new Promise((resolve, reject) => {
        let email = encodeURIComponent(this.state.email)
        superagent
          .get(`${__API_URI__}/password/get?userName=${email}`)
          .set('Content-Type', 'application/json')
          .set('Platform', 'Web')
          .set('Version', `${__version__}`)
          .end((err, res) => {
            if (err) {
              if (err.status == 401) {
                reject('error: ', err.status)
              }
              return reject('error: ', err.status)
            }
            resolve(res)
            this.setState({ emailError: '', emailSent: true })
          })
      })
    }
  }

  handleLogin(e) {
    e.preventDefault()

    this.handlePasswordReset(e).then(res => {
      let err = res.message ? res : null
      if (err) {
        if (err.status === 401) {
          this.setState({ emailError: 'Invalid password or email' })
          return
        }
        if (err.status === 503) {
          this.setState({ emailError: 'BaseMap is offline for updates' })
          return
        }
        if (err.status === 504) {
          this.setState({ emailError: 'BaseMap is offline for updates' })
          return
        }
        return this.setState({ emailError: 'There is an error with your email or password' })
      }
      let timeout = res.accessToken.expiresSeconds
      this.setState({ password: '' })
      // this.setState({ email: '' })
      // this.setState({ psdSent: true })
      this.props.userLoggedIn(timeout)
    })
      .catch(e => {
        console.log('Error: ', e)
      })
  }

  render() {
    const boxId = 'social-login'
    const css = {
      box: 'dialog-box-' + boxId,
      header: 'dialog-box-' + boxId + '__header',
      body: 'dialog-box-' + boxId + '__body',
      footer: 'dialog-box-' + boxId + '__footer'
    }
    const body =
      // !this.state.emailSent ?
      (
        <React.Fragment>
          {/* <p>Forgot Password</p> */}
          <div />
          {/* <div> */}
          {/* <label>EMAIL</label>
          <input
            type="email"
            name="email"
            placeholder="example@email.com"
            autoComplete="email"
            value={this.state.email}
            onChange={event => this.handleChange(event)}
          /> */}


          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <label style={{ marginBottom: '10px' }}>Email</label>
            <input
              type="email"
              name="email"
              autoComplete="email"
              value={this.state.email}
              onChange={event => this.handleChange(event)}
              className='login-email-input-style'
            />
          </div>
          {/* </div> */}
        </React.Fragment>
      )
    // : (
    //   <>
    //     <p style={{ textAlign: 'center' }}>Email sent!</p>
    //     <button onClick={e => this.props.slideInOutBackground('forgotPassword')}>OK</button>
    //   </>
    // )

    const footer = !this.state.emailSent ?
      (
        <React.Fragment>
          <div style={{ display: 'flex' }}>
            <button type="button" value="Submit" onClick={e => this.handleLogin(e)} id="forgot-password-button" >
              Submit
            </button>
            <button style={{ backgroundColor: 'grey' }} onClick={e => this.props.slideInOutBackground('forgotPassword')}>
              Cancel
            </button>
          </div>
          <div />
        </React.Fragment>
      )
      : null

    const content = {
      header: (
        <img
          src="../../../asset/Close-X_Thin_808080_ldpi.png"
          onClick={e => this.props.slideInOutBackground('forgotPassword')}
        />
      ),
      body,
      footer
    }

    return (
      // <div id={boxId} className={css.box + '-parent'}>
      //   {/* <form className={css.box + ' ' + css.box + '-parent__body__' + 'show'}>
      //     <div className={css.header}>{content.header}</div>
      //     <div className={css.body}>{content.body}</div>
      //     <div className={css.footer} style={{ marginTop: '-15px' }}>
      //       {content.footer}
      //     </div>
      //   </form> */}
      // </div>
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        {!this.state.emailSent ?
          <div className='container-forget-psd' >

            <div className='container-childs' >
              <a onClick={e => this.props.slideInOutBackground('forgotPassword')} style={{ textAlign: 'left', width: '100%', color: '#959595' }}>
                Cancel
              </a>
            </div>
            <div className='container-childs'>
              <img src={logoIcon} style={{ width: '100%', height: 31, }}></img>
            </div>
            <div className='container-childs' >
              <h1 className='password-resset-ctyle'>Password Reset</h1>
            </div>
            <div className='container-childs' >
              {content.body}
            </div>
            <div className='container-childs' >
              <p className='forgot-psd-text-style'>A password reset link will be sent to the email address entered above.</p>
            </div>
            <div className='container-childs'>
              <button type="button" value="Submit" onClick={e => this.handleLogin(e)} id="forgot-password-button" >
                Submit
              </button>
            </div>
            <div className='container-childs' >
              <p className='forgot-psd-text-style'>If you need further assistance, please reach out to us at support@basemap.com</p>
            </div>
          </div>
          :
          <div className='container-forget-psd' >
            <div className='container-childs' >
              <a onClick={e => this.props.slideInOutBackground('forgotPassword')} style={{ textAlign: 'right', width: '100%', color: '#959595' }}>
                X
              </a>
            </div>
            <div className='container-childs'>
              <img src={logoIcon} style={{ width: '100%', height: 31, }}></img>
            </div>
            <div className='container-childs' >
              <h1 className='password-resset-ctyle'> Success, Email sent to:</h1>
            </div>
            <div className='container-childs' >
              <h1 className='forgot-psd-email-style'>{this.state.email}</h1>
            </div>
            <div className='container-childs' >
              <p className='forgot-psd-text-style'>If you don't see it, please check your spam/junk folder.</p>
            </div>
            <div className='container-childs'>
              {/* <button type="button" value="Submit" onClick={e => this.handleLogin(e)} id="forgot-password-button" >
              Submit
            </button> */}
            </div>
            <div className='container-childs' >
              <p className='forgot-psd-text-style'>If you need further assistance, please reach out to us at support@basemap.com</p>
            </div>
          </div>}
      </div>
    )
  }
}

const mapStateToProps = state => ({
  auth: state.auth,
  user: state.user
})

const mapDispatchToProps = dispatch => ({
  authLogin: authObj => dispatch(authLoginRequest(authObj))
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ForgotPasswordDialog)
